'use strict';

module.exports = 0x39;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/var/HALF_WIDTH_NINE.js
// module id = 432
// module chunks = 0